import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=24fb2ce0&"
import script from "./audit.vue?vue&type=script&lang=ts&"
export * from "./audit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports